/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Attachments/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CommsThreadEventAttachments from 'DesignSystem/CommsThreadEventAttachments/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Attachments({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Internal/Content/Mine/Attachments"
  
}) {
let internalIdValueData = fromData.useDataValue({ viewPath,
context: 'internal',
path: 'id',
})
  return (<React.Fragment
>
<CommsThreadEventAttachments
  viewPath={`${viewPath}/CommsThreadEventAttachments`}
 data="internal.id"
 event_id={internalIdValueData}
/>
{children}
</React.Fragment>)
}